module.exports = __webpack_public_path__ + "static/img/1-10.f6d0783.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/home/1-10.png
// module id = NDsw
// module chunks = 15